/* GiftLayer theme JS — hero animation, mobile nav, reveal-on-scroll, PDP gallery + live preview, cart */
(function () {
  document.documentElement.classList.add('gl-js');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(id) { return document.getElementById(id); }

  /* ---------- shared: layered letter rendering ---------- */
  function shade(hex, f) {
    var n = parseInt(hex.slice(1), 16);
    var r = Math.round((n >> 16 & 255) * f), g = Math.round((n >> 8 & 255) * f), b = Math.round((n & 255) * f);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }
  function tint(hex, a) {
    var n = parseInt(hex.slice(1), 16);
    return 'rgba(' + (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255) + ',' + a + ')';
  }
  function fitName(el) {
    el.style.fontSize = '';
    if (!el.children.length || !el.parentElement) return;
    var w = 0;
    for (var i = 0; i < el.children.length; i++) w += el.children[i].offsetWidth;
    w *= 1.04; /* letter gaps + slight rotations */
    var ps = getComputedStyle(el.parentElement);
    var avail = el.parentElement.clientWidth - parseFloat(ps.paddingLeft) - parseFloat(ps.paddingRight);
    if (avail > 0 && w > avail) {
      var fs = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = Math.max(16, fs * avail / w * 0.98) + 'px';
    }
  }
  function layered(el, name, color, popLast) {
    el.innerHTML = '';
    var deep = shade(color, 0.8), deeper = shade(color, 0.58);
    name.split('').forEach(function (ch, i, arr) {
      var s = document.createElement('span');
      s.className = 'ltr';
      s.textContent = ch === ' ' ? ' ' : ch;
      s.style.color = color;
      s.style.textShadow = '0 0.042em 0 ' + deep + ', 0 0.084em 0 ' + deeper + ', 0 0.16em 0.06em rgba(45,48,52,0.16)';
      if (popLast && i === arr.length - 1 && !reduced) s.classList.add('pop');
      el.appendChild(s);
    });
    var caret = document.createElement('span');
    caret.className = 'caret';
    el.appendChild(caret);
    fitName(el);
  }

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

  /* ---------- mobile nav ---------- */
  var navMenu = $('glMainNav');
  var navToggle = $('glNavToggle');
  if (navMenu && navToggle) {
    navToggle.addEventListener('click', function () {
      var open = navMenu.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', open);
    });
    navMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        navMenu.classList.remove('open');
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- marquee seamless loop ---------- */
  var track = $('glMarqueeTrack');
  if (track && track.querySelector('span')) {
    track.appendChild(track.querySelector('span').cloneNode(true));
  }

  /* ---------- hero typing animation ---------- */
  var stage = $('glHeroName'), heroInput = $('glNameInput');
  if (stage) {
    var names = (stage.dataset.names || 'Aarav,Meera,Ishaan,Zoya,Priya').split(',');
    var heroColor = '#F26D7D';
    var ni = 0, timer = null, userTookOver = false;

    var heroRender = function (name, animateAll) {
      layered(stage, name, heroColor, false);
      if (animateAll && !reduced) {
        stage.querySelectorAll('.ltr').forEach(function (s, i) {
          s.classList.add('pop');
          s.style.animationDelay = (i * 0.07) + 's';
        });
      }
    };
    var typeName = function (name, done) {
      var i = 0;
      heroRender('');
      timer = setInterval(function () {
        if (userTookOver) return;
        i++;
        heroRender(name.slice(0, i));
        var ls = stage.querySelectorAll('.ltr');
        if (ls.length && !reduced) ls[ls.length - 1].classList.add('pop');
        if (i >= name.length) { clearInterval(timer); setTimeout(done, 2600); }
      }, 160);
    };
    var eraseName = function (name, done) {
      var i = name.length;
      timer = setInterval(function () {
        if (userTookOver) return;
        i--;
        heroRender(name.slice(0, i));
        if (i <= 0) { clearInterval(timer); setTimeout(done, 350); }
      }, 70);
    };
    var cycle = function () {
      if (userTookOver) return;
      var name = names[ni % names.length];
      ni++;
      typeName(name, function () {
        if (userTookOver) return;
        eraseName(name, cycle);
      });
    };
    heroRender(names[0], true);
    ni = 1;
    setTimeout(function () { if (!userTookOver) eraseName(names[0], cycle); }, 3400);

    if (heroInput) {
      var takeOver = function () {
        if (userTookOver) return;
        userTookOver = true;
        if (timer) clearInterval(timer);
        heroRender(heroInput.value || '');
      };
      heroInput.addEventListener('focus', takeOver);
      heroInput.addEventListener('input', function () {
        takeOver();
        heroRender(heroInput.value.slice(0, 12));
        var ls = stage.querySelectorAll('.ltr');
        if (ls.length && !reduced) ls[ls.length - 1].classList.add('pop');
      });
    }
  }

  /* ---------- track order: courier shortcut ---------- */
  var trackForm = $('glTrackForm');
  if (trackForm) {
    var trackErr = $('glTrackError');
    var showTrackError = function (msg) {
      if (!trackErr) return;
      trackErr.textContent = msg;
      trackErr.hidden = false;
    };
    trackForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (trackErr) trackErr.hidden = true;

      var sel = $('glTrackCourier');
      var num = ($('glTrackNumber').value || '').trim();
      if (!num) {
        showTrackError('Enter the tracking number from your dispatch email.');
        $('glTrackNumber').focus();
        return;
      }
      var pattern = sel && sel.value;
      if (!pattern || pattern.indexOf('{tracking}') === -1) {
        showTrackError('This courier has no tracking link set up yet — please contact us instead.');
        return;
      }
      /* open in a new tab so the customer keeps our page behind them */
      window.open(pattern.replace('{tracking}', encodeURIComponent(num)), '_blank', 'noopener');
    });
  }

  /* ---------- FAQ: highlight the category you're reading ---------- */
  var rail = document.querySelector('.faq__rail');
  if (rail && 'IntersectionObserver' in window) {
    var links = rail.querySelectorAll('a[data-rail]');
    var groups = document.querySelectorAll('.faq__group');
    var setActive = function (id) {
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
      });
    };
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) setActive(en.target.id);
      });
    }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
    groups.forEach(function (g) { spy.observe(g); });
    if (groups.length) setActive(groups[0].id);
  }

  /* ---------- FAQ: deep-link to a question via #hash ---------- */
  if (location.hash) {
    try {
      var target = document.querySelector(location.hash);
      if (target && target.tagName === 'DETAILS') {
        target.open = true;
        target.scrollIntoView({ block: 'center' });
      }
    } catch (e) { /* malformed hash — nothing to open */ }
  }

  /* ---------- lead popup ---------- */
  var pop = $('glPop');
  if (pop) {
    var KEY = 'gl_pop_dismissed_until';
    var card = pop.querySelector('.gl-pop__card');
    var lastFocus = null;

    var suppressed = function () {
      try {
        var until = parseInt(localStorage.getItem(KEY) || '0', 10);
        return until > new Date().getTime();
      } catch (e) { return false; }  /* private mode: just show it */
    };
    var suppress = function () {
      try {
        var days = parseInt(pop.dataset.rememberDays, 10) || 14;
        localStorage.setItem(KEY, new Date().getTime() + days * 86400000);
      } catch (e) { /* nothing to do */ }
    };

    var closePop = function () {
      pop.hidden = true;
      suppress();
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    };
    var openPop = function () {
      if (!pop.hidden) return;
      lastFocus = document.activeElement;
      pop.hidden = false;
      document.body.style.overflow = 'hidden';
      var first = pop.querySelector('input:not([type=hidden]), button');
      if (first) first.focus();
    };

    pop.querySelectorAll('[data-pop-close]').forEach(function (el) {
      el.addEventListener('click', closePop);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) closePop();
      /* keep tab focus inside the dialog while it's open */
      if (e.key === 'Tab' && !pop.hidden && card) {
        var f = card.querySelectorAll('a[href], button, input:not([type=hidden]), textarea');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* a successful contact-form post reloads with ?contact_posted=true — show the thank-you */
    var posted = location.search.indexOf('contact_posted=true') > -1;
    if (posted) {
      openPop();
      suppress();
    } else if (!suppressed()) {
      var delay = (parseInt(pop.dataset.delay, 10) || 8) * 1000;
      setTimeout(openPop, delay);
    }
  }

  /* ---------- product page: image gallery ---------- */
  var gal = $('glGallery');
  if (gal) {
    var slides = gal.querySelectorAll('.pgal-slide');
    var thumbs = gal.querySelectorAll('.pgal-thumb');
    var current = 0;

    var show = function (i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) {
        slides[s].classList.toggle('on', s === current);
      }
      for (var t = 0; t < thumbs.length; t++) {
        var active = t === current;
        thumbs[t].classList.toggle('on', active);
        thumbs[t].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    };

    thumbs.forEach(function (b) {
      b.addEventListener('click', function () { show(parseInt(b.dataset.i, 10)); });
    });
    gal.querySelectorAll('.pgal-arrow').forEach(function (b) {
      b.addEventListener('click', function () { show(current + parseInt(b.dataset.dir, 10)); });
    });
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { show(current + 1); }
      else if (e.key === 'ArrowLeft') { show(current - 1); }
    });

    /* swipe on touch devices */
    var sx = null, sy = null;
    gal.addEventListener('touchstart', function (e) {
      sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY;
    }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
      sx = sy = null;
    }, { passive: true });
  }

  /* ---------- cart page ---------- */
  var cartForm = $('glCartForm');
  if (cartForm) {
    /* form.submit() on purpose, not requestSubmit(): requestSubmit() would attach the
       form's default submitter — the "checkout" button — and send people straight to
       checkout on a quantity change. A bare POST to /cart just updates and re-renders. */
    var submitUpdate = function () { cartForm.submit(); };

    /* quantity steppers submit the form so the server stays the source of truth */
    cartForm.querySelectorAll('.qty').forEach(function (box) {
      var input = box.querySelector('input[name="updates[]"]');
      if (!input) return;
      box.querySelectorAll('.qty-btn').forEach(function (b) {
        b.addEventListener('click', function () {
          var next = (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10);
          if (next < 0) next = 0;
          input.value = next;
          submitUpdate();
        });
      });
      input.addEventListener('change', submitUpdate);
    });

    /* the gift note is saved on its own so a quantity change or remove never drops it */
    var note = $('glCartNote');
    var noteFlag = $('glNoteSaved');
    if (note) {
      var lastSaved = note.value;
      var saveNote = function () {
        if (note.value === lastSaved) return;
        lastSaved = note.value;
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).then(function (r) {
          if (noteFlag) noteFlag.textContent = r.ok ? 'Saved ✓' : 'Saved at checkout';
        }).catch(function () {
          if (noteFlag) noteFlag.textContent = 'Saved at checkout';
        });
      };
      note.addEventListener('blur', saveNote);
      /* remove links leave the page — flush the note first */
      cartForm.querySelectorAll('.cl-remove').forEach(function (a) {
        a.addEventListener('mousedown', saveNote);
      });
    }
  }

  /* ---------- product page: live preview + personalization ---------- */
  var pv = $('glPreviewCanvas');
  var pInput = $('glPName');
  var redrawPreview = null;
  if (pv && pInput && window.GLPreview) {
    var firstStyle = document.querySelector('#glStyleSeg button.on');
    var stage3d = $('glPreviewStage');
    var heartBox = $('glHeart');
    var model = (stage3d && stage3d.dataset.model) || 'letter';
    var state = {
      name: '',
      style: {
        label: firstStyle ? firstStyle.dataset.label : 'Pacifico',
        font: firstStyle ? firstStyle.dataset.font : 'Pacifico',
        font3d: firstStyle ? firstStyle.dataset.font3d : null
      },
      color: { label: 'Blush', hex: '#F26D7D' },
      heart: heartBox ? heartBox.checked : true
    };
    var panel = $('glPreviewPanel');
    var hint = $('glPreviewHint');
    var pending = false;
    var view3d = null;
    /* the flat canvas only knows how to draw the name letter */
    var flatSupported = model === 'letter';

    /* the canvas is redrawn from scratch, so coalesce bursts of keystrokes */
    var updatePreview = function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var dim = !state.name;
        /* dim the whole stage, not the flat canvas — an inline opacity here
           would outrank the rule that hides it once the 3D view takes over */
        if (stage3d) stage3d.classList.toggle('is-dim', dim);
        if (flatSupported && GLPreview.fit(pv)) {
          GLPreview.render(pv, {
            name: state.name || 'Their name',
            initialFont: 'Playfair Display',
            nameFont: state.style.font,
            initialColor: state.color.hex,
            nameColor: '#EDE3D2',
            background: 'transparent'
          });
        }
        if (view3d) {
          view3d.set({
            model: model,
            name: state.name || 'Their name',
            nameFontUrl: state.style.font3d,
            heart: state.heart,
            initialColor: state.color.hex,
            /* the keychain's raised name is white; the letter's is cream */
            nameColor: model === 'keychain' ? '#FFFFFF' : '#EDE3D2',
            accentColor: '#F4A7C0'
          });
        }
        if (panel) panel.style.background = tint(state.color.hex, 0.13);
        if (hint) hint.textContent = dim ? 'Start typing to see it come to life.' : 'This is exactly what we’ll make.';
      });
    };

    /* Upgrade to the real 3D view once its bundle arrives. The flat canvas has
       already painted by then, so this only ever swaps one picture for a better
       one — if WebGL or the bundle is unavailable, the flat one simply stays. */
    (function load3d() {
      var stage = stage3d, cv3 = $('glPreviewCanvas3D');
      /* a model with no flat fallback has nothing to show if 3D never arrives */
      var giveUp = function () { if (!flatSupported) stage.classList.add('is-empty'); };
      if (!stage || !cv3 || !stage.dataset.bundle) return giveUp();
      if (!window.WebGLRenderingContext) return giveUp();
      var probe = document.createElement('canvas');
      if (!probe.getContext('webgl2') && !probe.getContext('webgl')) return giveUp();

      var s = document.createElement('script');
      s.src = stage.dataset.bundle;
      s.async = true;
      s.onerror = giveUp;
      s.onload = function () {
        if (!window.GLPreview3D) return giveUp();
        try {
          view3d = window.GLPreview3D.create(cv3);
        } catch (e) {
          return giveUp();                      /* keep the flat preview */
        }
        view3d.set({
          model: model,
          name: state.name || 'Their name',
          initialFontUrl: stage.dataset.fontInitial,
          nameFontUrl: state.style.font3d,
          heart: state.heart,
          initialColor: state.color.hex,
          nameColor: model === 'keychain' ? '#FFFFFF' : '#EDE3D2',
          accentColor: '#F4A7C0'
        });
        stage.classList.add('is-3d');
        view3d.resize();
      };
      document.head.appendChild(s);
    })();

    /* canvas text needs the webfonts resolved before it can measure anything */
    if (document.fonts && document.fonts.load) {
      Promise.all([
        document.fonts.load('700 100px "Playfair Display"'),
        document.fonts.load('100px "Pacifico"'),
        document.fonts.load('100px "Lobster"'),
        document.fonts.load('100px "Great Vibes"')
      ]).then(updatePreview, updatePreview);
    }

    pInput.addEventListener('input', function () {
      state.name = pInput.value.slice(0, 12);
      updatePreview();
    });

    document.querySelectorAll('#glStyleSeg button').forEach(function (b) {
      b.addEventListener('click', function () {
        state.style = { label: b.dataset.label, font: b.dataset.font, font3d: b.dataset.font3d };
        document.querySelectorAll('#glStyleSeg button').forEach(function (x) {
          x.classList.remove('on');
          x.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('on');
        b.setAttribute('aria-pressed', 'true');
        var hiddenStyle = $('glStyleInput');
        if (hiddenStyle) hiddenStyle.value = b.dataset.label;
        updatePreview();
      });
    });
    document.querySelectorAll('#glSwatches .swatch').forEach(function (b) {
      b.addEventListener('click', function () {
        state.color = { label: b.dataset.label, hex: b.dataset.hex };
        document.querySelectorAll('#glSwatches .swatch').forEach(function (x) {
          x.classList.remove('on');
          x.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('on');
        b.setAttribute('aria-pressed', 'true');
        var cn = $('glColName');
        if (cn) cn.textContent = b.dataset.label;
        var hiddenCol = $('glColourInput');
        if (hiddenCol) hiddenCol.value = b.dataset.label;
        updatePreview();
      });
    });

    if (heartBox) {
      heartBox.addEventListener('change', function () {
        state.heart = heartBox.checked;
        updatePreview();
      });
    }

    redrawPreview = updatePreview;

    /* prefill from ?name= (hero form hands off here) */
    try {
      var qname = new URLSearchParams(location.search).get('name');
      if (qname) {
        state.name = qname.slice(0, 12);
        pInput.value = state.name;
      }
    } catch (e) { /* older browsers: skip prefill */ }

    /* require a name before add to cart */
    var form = $('glProductForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!pInput.value.trim()) {
          e.preventDefault();
          pInput.focus();
          pInput.style.borderColor = '#F26D7D';
        }
      });
    }

    updatePreview();
  }

  /* ---------- refit names on resize ---------- */
  var fitTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(function () {
      if (stage) fitName(stage);
      /* the canvas backing store is tied to its CSS box, so it must be redrawn */
      if (redrawPreview) redrawPreview();
    }, 120);
  });
})();
